import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ImplementationStrategy  {
    _originalTypeClassName = "zAppDevManager.BO.ImplementationStrategy";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ImplementationStrategy.translate = translateService;
}
this.Id = null;
this.Description = null;
this.Price = null;
this._key = this.Id = ""; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Description:any;
Price:any;

static SerializeRow(row: any): any{let s = new Domain.ImplementationStrategy();
s.Id = Joove.Common.cast(row.get("Id"), "string");
s.Description = Joove.Common.cast(row.get("Description"), "string");
s.Price = Joove.Common.cast(row.get("Price"), "number");
return s;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == "";
            }


}